/* Flex-Autoteile: rebuild supplier HTML as semantic content, never copy its CSS. */
(() => {
  'use strict';
  if (customElements.get('fa-description')) return;
  const allowed = new Set('p div span section article h3 br hr strong b em i u s small sub sup ul ol li dl dt dd table thead tbody tfoot tr th td caption figure figcaption blockquote pre code a img address abbr'.split(' '));
  const discard = new Set('script style link meta base template noscript input button select textarea option object embed applet canvas'.split(' '));
  const rename = { h1: 'h3', h2: 'h3', h4: 'h3', h5: 'h3', h6: 'h3', center: 'div', font: 'span', details: 'section', summary: 'h3' };
  let sequence = 0;
  function safeURL(value, image = false) {
    if (!value || /[\u0000-\u001f\u007f]/.test(value)) return null;
    try {
      const url = new URL(value.trim(), document.baseURI);
      if (url.username || url.password) return null;
      const protocols = image ? ['https:'] : ['https:', 'http:', 'mailto:', 'tel:'];
      return protocols.includes(url.protocol) ? url.href : null;
    } catch (_) { return null; }
  }
  function render(source, prefix, tableLabel) {
    // Both the escaped source template and this parser template stay inert.
    const parser = document.createElement('template');
    parser.innerHTML = source;
    const ids = new Map();
    parser.content.querySelectorAll('[id]').forEach(node => {
      if (!ids.has(node.id)) ids.set(node.id, `${prefix}-${ids.size + 1}`);
    });
    function build(node) {
      if (node.nodeType === Node.TEXT_NODE) return document.createTextNode(node.data);
      if (node.nodeType !== Node.ELEMENT_NODE) return document.createDocumentFragment();
      if (node.namespaceURI !== 'http://www.w3.org/1999/xhtml') return document.createDocumentFragment();
      const original = node.localName;
      if (discard.has(original)) return document.createDocumentFragment();
      if (original === 'iframe' || original === 'video' || original === 'audio') {
        const href = safeURL(node.getAttribute('src') || node.querySelector('source')?.getAttribute('src'));
        if (!href) return document.createDocumentFragment();
        const link = document.createElement('a');
        link.href = href; link.textContent = node.getAttribute('title') || 'Produktmedium öffnen';
        link.target = '_blank'; link.rel = 'noopener noreferrer';
        return link;
      }
      const tag = rename[original] || original;
      const out = allowed.has(tag) ? document.createElement(tag) : document.createDocumentFragment();
      if (out.nodeType === Node.ELEMENT_NODE) {
        // Do not copy style, class, width, height, event attributes or supplier IDs.
        if (node.id && ids.has(node.id)) out.id = ids.get(node.id);
        const language = node.getAttribute('lang');
        if (language && /^[a-zA-Z0-9-]{2,35}$/.test(language)) out.lang = language;
        const direction = node.getAttribute('dir');
        if (['ltr', 'rtl', 'auto'].includes(direction)) out.dir = direction;
        if (node.hasAttribute('title')) out.title = node.getAttribute('title');
        if (tag === 'a') {
          const raw = node.getAttribute('href') || '';
          const href = raw.startsWith('#') ? (ids.has(raw.slice(1)) ? `#${ids.get(raw.slice(1))}` : null) : safeURL(raw);
          if (href) {
            out.setAttribute('href', href);
            if (/^https?:/.test(href) && new URL(href).origin !== location.origin) {
              out.target = '_blank'; out.rel = 'noopener noreferrer';
            }
          }
        }
        if (tag === 'img') {
          const raw = node.getAttribute('src') || node.getAttribute('data-src');
          const src = safeURL(raw, true);
          const alt = node.getAttribute('alt') || '';
          if (!src) {
            const linkURL = safeURL(raw);
            if (!linkURL) return document.createTextNode(alt);
            const link = document.createElement('a'); link.href = linkURL;
            link.textContent = alt || 'Produktabbildung öffnen';
            link.target = '_blank'; link.rel = 'noopener noreferrer'; return link;
          }
          out.src = src; out.alt = alt; out.loading = 'lazy'; out.decoding = 'async';
        }
        if (tag === 'td' || tag === 'th') {
          for (const attr of ['colspan', 'rowspan']) {
            const value = node.getAttribute(attr);
            if (value && /^[1-9]\d?$/.test(value)) out.setAttribute(attr, value);
          }
          if (tag === 'th' && ['row', 'col', 'rowgroup', 'colgroup'].includes(node.getAttribute('scope'))) out.setAttribute('scope', node.getAttribute('scope'));
        }
        if (tag === 'ol' && /^-?\d{1,6}$/.test(node.getAttribute('start') || '')) out.setAttribute('start', node.getAttribute('start'));
        if (tag === 'table' && node.classList.contains('flxdesc-attr-table')) out.className = 'fa-description-table--specs';
      }
      for (const child of node.childNodes) out.appendChild(build(child));
      return out;
    }
    const result = document.createDocumentFragment();
    for (const child of parser.content.childNodes) result.appendChild(build(child));
    result.querySelectorAll('p').forEach(p => {
      if (!p.textContent.trim() && !p.querySelector('img,a[href]')) { p.remove(); return; }
      const children = Array.from(p.childNodes).filter(n => n.nodeType !== Node.TEXT_NODE || n.textContent.trim());
      if (children.length === 1 && ['B', 'STRONG'].includes(children[0].nodeName)) {
        const heading = document.createElement('h3');
        heading.textContent = p.textContent.trim();
        if (p.id) heading.id = p.id;
        p.replaceWith(heading);
      } else if (children.length > 2 && ['B', 'STRONG'].includes(children[0].nodeName) && children[1].nodeName === 'BR' && children[0].textContent.trim().length <= 80) {
        const heading = document.createElement('h3');
        heading.textContent = children[0].textContent.trim();
        if (p.id) { heading.id = p.id; p.removeAttribute('id'); }
        children[0].remove(); children[1].remove();
        p.before(heading);
      }
    });
    result.querySelectorAll('table').forEach(table => {
      const rows = Array.from(table.rows);
      if (rows.length && rows.every(row => row.cells.length === 2 && Array.from(row.cells).every(c => c.colSpan === 1))) table.classList.add('fa-description-table--pairs');
      if (table.classList.contains('fa-description-table--specs')) {
        rows.forEach(row => {
          const first = row.cells[0];
          if (first?.localName !== 'td') return;
          const label = document.createElement('th'); label.scope = 'row';
          label.append(...first.childNodes); first.replaceWith(label);
        });
      }
      const wrapper = document.createElement('div');
      wrapper.className = 'fa-description-table'; wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region'); wrapper.setAttribute('aria-label', tableLabel);
      table.replaceWith(wrapper); wrapper.appendChild(table);
    });
    result.querySelectorAll('h3').forEach(heading => {
      if (!/^(hersteller|verantwortliche person für die eu|eu-verantwortliche person)$/i.test(heading.textContent.trim())) return;
      const section = document.createElement('section'); section.className = 'fa-description-entity';
      heading.replaceWith(section); section.appendChild(heading);
      while (section.nextElementSibling?.localName === 'p') section.appendChild(section.nextElementSibling);
    });
    return result;
  }
  class FADescription extends HTMLElement {
    connectedCallback() {
      if (this.dataset.faRendered === 'true') return;
      if (!this.update()) {
        this.observer = new MutationObserver(() => { if (this.update()) this.observer.disconnect(); });
        this.observer.observe(this, { childList: true });
      }
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    update() {
      const source = this.querySelector('template[data-fa-source]');
      const target = this.querySelector('[data-fa-description]');
      if (!source || !target) return false;
      try {
        const clean = render(source.content.textContent, `fa-description-${++sequence}`, this.dataset.tableLabel || 'Produktdaten');
        target.replaceChildren(clean);
        this.dataset.faRendered = 'true';
      } catch (error) {
        // Leave the server-rendered, escaped plain-text fallback readable.
        this.dataset.faRendered = 'fallback';
        console.warn('Product description formatting unavailable.', error);
      }
      return true;
    }
  }
  customElements.define('fa-description', FADescription);
})();
